import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import './productSearch.scss';

/*-- Import required components --*/
import AutoCompleteText from './AutoCompleteText';
import CategoryMenu from '../categoryMenu/CategoryMenu';
import CategoryMobileMenu from '../categoryMenu/CategoryMobileMenu';
import { productListingTypeEnum, productSearchLengthEnum } from '../../utility/enums';
import { CheckMobileAccessory, genarateProductSearchURL } from '../../utility/commonFunctions';

/*-- Imports for redux --*/
import { connect } from 'react-redux';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        webDataCollection: state.webDataCollection
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {};

/**
 * Date     :   2020-06-16
 * Author   :   Dinushka Rukshan
 * Remarks  :   Product search component with category menu
 */
class ProductSearch extends Component {
    constructor(props) {
        super(props)
        this.autoCompleteRef = React.createRef();
        this.categoryMenuRef = React.createRef();

        this.state = {}
    };

    toggleCategoryMenu() {
        this.categoryMenuRef.current.toggleCategoryMenu();
    };

    searchProductClick() {
        const searchQuery = this.autoCompleteRef.current.state.searchText;
        if (searchQuery !== "" && searchQuery !== null) {
            if (searchQuery.length > productSearchLengthEnum.productSearchLength) {
                window.location.href = genarateProductSearchURL(searchQuery);
            }
        }
    };

    render() {
        return (
            <Row style={{ margin: 0 }}>
                <Col lg="12" md="12" sm="12" xs="12">
                    <div className="product-search">
                        <div className="category_menu_btn_product_search" onClick={this.toggleCategoryMenu.bind(this)}>
                            {
                                (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?
                                    <i className="fas fa-list"></i> :
                                    <React.Fragment>
                                        <span>Categories </span><i className="fas fa-angle-down" style={{ paddingLeft: "0.9375rem" }}></i>
                                    </React.Fragment>
                            }
                        </div>
                        <AutoCompleteText ref={this.autoCompleteRef} />
                        <button className="product-search-button" onClick={this.searchProductClick.bind(this)}>
                            {
                                (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?
                                    <i className="fas fa-search"></i> :
                                    <React.Fragment>
                                        <span>SEARCH PRODUCTS </span><i className="fas fa-search" style={{ paddingLeft: "0.625rem" }}></i>
                                    </React.Fragment>
                            }
                        </button>
                    </div>
                    {
                        (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?
                            <CategoryMobileMenu ref={this.categoryMenuRef} /> :
                            <CategoryMenu ref={this.categoryMenuRef} />
                    }
                </Col >
            </Row>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductSearch);